import { useEffect, useState } from 'react';

/**
 *
   const scriptStatus = useScript('https://myscript-url.com.js', 'my-script-id', () => {
    console.log('My custom script loaded!');
  });

  useEffect(() => {
    if (scriptStatus === 'success') {
      console.log('Script loaded successfully!');
    } else if (scriptStatus === 'error') {
      console.error('Script failed to load.');
    }
  }, [scriptStatus]);
 */

const useScript = (src, id, onLoadCallback) => {
  const [status, setStatus] = useState(src ? 'loading' : 'idle');

  useEffect(() => {
    if (!src) {
      return null;
    }

    let script = document?.getElementById(id);

    // Handle script load and error events
    const onScriptLoad = () => {
      setStatus('success');
      if (onLoadCallback) {
        onLoadCallback();
      }
    };

    const onScriptError = () => {
      setStatus('error');
    };

    if (!script) {
      // Create a new script element
      script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.id = id;

      // Append the script to the document head
      document.head.appendChild(script);

      script.addEventListener('load', onScriptLoad);
      script.addEventListener('error', onScriptError);
    }

    setStatus('success');
    if (onLoadCallback) {
      onLoadCallback();
    }

    return () => {
      if (script) {
        script.removeEventListener('load', onScriptLoad);
        script.removeEventListener('error', onScriptError);
      }
    };
  }, [id, onLoadCallback, src]);

  return status;
};

export default useScript;
